var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-sub',{attrs:{"name":"intro"}},[_c('base-horizontal-card',{staticClass:"p-intro",attrs:{"img":require('@/assets/img-intro.jpg'),"detail":_vm.content,"border-variant":"white","img-right":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }